import { useEffect, useState } from "react";
import { BellRing, BellOff, Bell } from "lucide-react";
import { toast } from "sonner";
import { pushSupported, isPushEnabled, enablePush, disablePush, sendTestPush } from "../lib/push";

// Lets the admin enable browser push notifications for new reservation requests.
export function PushToggle() {
  const [supported] = useState(pushSupported());
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (supported) isPushEnabled().then(setEnabled).catch(() => {});
  }, [supported]);

  if (!supported) return null;

  const enable = async () => {
    setBusy(true);
    try {
      await enablePush();
      setEnabled(true);
      toast.success("Push notifications enabled — sending a test...");
      await sendTestPush();
    } catch (e) {
      if (e.message === "denied") toast.error("Notifications were blocked. Enable them in your browser settings.");
      else toast.error("Could not enable notifications.");
    } finally {
      setBusy(false);
    }
  };

  const disable = async () => {
    setBusy(true);
    try {
      await disablePush();
      setEnabled(false);
      toast.success("Push notifications turned off.");
    } catch {
      toast.error("Could not turn off notifications.");
    } finally {
      setBusy(false);
    }
  };

  return enabled ? (
    <button onClick={disable} disabled={busy} data-testid="push-disable-button"
      className="inline-flex items-center gap-2 bg-green-50 text-green-700 border border-green-200 hover:bg-green-100 font-heading font-semibold text-sm py-2 px-4 rounded-full transition-colors">
      <BellRing size={16} /> Alerts On
    </button>
  ) : (
    <button onClick={enable} disabled={busy} data-testid="push-enable-button"
      className="inline-flex items-center gap-2 bg-brand-blue hover:bg-brand-blue/90 text-white font-heading font-bold text-sm py-2 px-4 rounded-full transition-colors disabled:opacity-60">
      <Bell size={16} /> {busy ? "Enabling..." : "Enable Notifications"}
    </button>
  );
}

export default PushToggle;
